import { Injectable } from '@angular/core';
import { environment } from './../../../../environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { catchError, Observable, throwError } from 'rxjs';
import {
  Fund,
  FundClosing,
  FundClosingPaged,
  FundCreationFields,
  FundPaged,
  FundsCreationFormFields,
  FundsCreationRequestFields,
  ReducedFundData,
  StatusChange,
} from '../../models/fund.model';
import { cleanEmptyProps } from '../../functions/object-to-queryparams';
import { PaginationForm } from '../../models/pagination.model';
import { FundsConveyor } from '../../models/funds-conveyor.models';

@Injectable({
  providedIn: 'root',
})
export class FundService {
  private readonly API_FUNDS = `${environment.api_url}/Fundo`;
  private readonly MOCKED_API =
    'https://run.mocky.io/v3/63661958-95c4-4948-8f88-4d26d4a94a29';

  constructor(private http: HttpClient) {}

  //trocar caminho quando for trocar de API

  getAllPaged(filter: Partial<PaginationForm> = null): Observable<FundPaged> {
    return this.http.get<FundPaged>(`${this.API_FUNDS}/GetAllPaged`, {
      params: cleanEmptyProps(filter),
    });
  }

  create(body: FundCreationFields): Observable<FundCreationFields> {
    return this.http.post<FundCreationFields>(`${this.API_FUNDS}/Fundo`, body);
  }

  update(fundBody: FundCreationFields): Observable<FundCreationFields> {
    return this.http.put<FundCreationFields>(
      `${this.API_FUNDS}/Fundo`,
      fundBody
    );
  }

  getById(id: number): Observable<FundsCreationRequestFields> {
    return this.http.get<FundsCreationRequestFields>(
      `${this.API_FUNDS}/GetById/${id}`
    );
  }

  getReducedFundsData(): Observable<ReducedFundData[]> {
    return this.http.get<ReducedFundData[]>(`${this.API_FUNDS}/GetAllMinimo`);
  }

  changeStatus(status: StatusChange): Observable<void> {
    return this.http.post<void>(`${this.MOCKED_API}`, status);
  }

  changeFundsDate(data: Date, fundos: number[]): Observable<void> {
    return this.http.post<void>(`${this.MOCKED_API}`, {
      data,
      fundos,
    });
  }

  getFundClosing(
    filters: Partial<PaginationForm> = null
  ): Observable<FundClosingPaged> {
    return this.http.get<FundClosingPaged>(
      `${this.API_FUNDS}/GetFechamentoFundo`,
      {
        params: cleanEmptyProps(filters),
      }
    );
  }

  includeOnProcessQeue(
    cnpjs: string[],
    dataFinal: string,
    tipo: string,
    idUsuario: number
  ): Observable<void> {
    return this.http.post<void>(
      `${this.API_FUNDS}/InserirFilaProcessamento/${dataFinal}/${tipo}/${idUsuario}`,
      cnpjs
    );
  }

  getFundByCnpj(cnpj: string): Observable<Fund> {
    return this.http.get<Fund>(`${this.API_FUNDS}/GetByCnpj/${cnpj}`);
  }

  downloadArquivosFundosAtrasados(id: number): Observable<unknown> {
    return this.http.post<unknown>(`${this.API_FUNDS}`, id);
  }

  esteiraFundos(): Observable<FundsConveyor[]> {
    return this.http.get<FundsConveyor[]>(`${this.API_FUNDS}/fundspipeline`)
  }
}
